import { Grid } from '@mui/material';

export const Note = ({ value }) => (
  <Grid item className="note" xs={12}>
    {value.length < 50 ? (
      <h3>{value}</h3>
    ) : (
      <h4 style={{ fontSize: '17px' }}>{value}</h4>
    )}
  </Grid>
);
